var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("scheduler-input", {
    attrs: {
      defaultValue: _vm.defaultValue,
      timeZone: _vm.timeZone,
      onChange: _vm.onChange,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }